import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtomahabaleshwarcab() {



    const cardData = {


keyword: "Belgaum to Mahabaleshwar Cab",

headingDescription: "Belgaum Taxi Service offers reliable Belgaum to Mahabaleshwar cab services for family vacations, weekend getaways, corporate travel, honeymoon trips, sightseeing tours, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Mahabaleshwar, we provide safe, comfortable, and affordable travel with professional chauffeurs and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars to suit your travel needs. We ensure doorstep pickup, flexible departure timings, transparent pricing, easy online booking, and 24/7 customer support for a hassle-free journey. Belgaum Taxi Service is committed to providing a smooth travel experience with comfortable rides to Mahabaleshwar's famous tourist attractions, hotels, resorts, and nearby sightseeing destinations.",

topPlaces: [
  {
    title: "Venna Lake",
    description: "Venna Lake is one of Mahabaleshwar's most popular attractions, offering boating, horse riding, food stalls, and beautiful surroundings for families and tourists."
  },
  {
    title: "Mapro Garden",
    description: "Mapro Garden is a famous tourist destination known for fresh strawberries, fruit products, delicious food, chocolate treats, and a relaxing garden atmosphere."
  },
  {
    title: "Wilson Point",
    description: "Wilson Point is the highest viewpoint in Mahabaleshwar and is well known for breathtaking sunrise views and panoramic landscapes."
  },
  {
    title: "Arthur's Seat",
    description: "Arthur's Seat is one of the most famous viewpoints in Mahabaleshwar, offering spectacular valley views, cliffs, and scenic photography spots."
  },
  {
    title: "Elephant's Head Point",
    description: "Elephant's Head Point is a popular viewpoint named after its naturally shaped rock formation, attracting visitors with its stunning mountain scenery."
  },
  {
    title: "Lingmala Waterfall",
    description: "Lingmala Waterfall is surrounded by lush greenery and offers a refreshing natural escape, especially during the monsoon season."
  },
  {
    title: "Pratapgad Fort",
    description: "Pratapgad Fort is a historic Maratha fort near Mahabaleshwar, famous for its architecture, history, and panoramic views of the surrounding hills."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a scenic hill station located near Mahabaleshwar, known for Table Land, viewpoints, boarding schools, and pleasant weather throughout the year."
  },
  {
    title: "Kate's Point",
    description: "Kate's Point offers magnificent views of the Krishna Valley, Dhom Dam, and surrounding mountains, making it a favorite stop for sightseeing."
  },
  {
    title: "Bombay Point",
    description: "Bombay Point is one of Mahabaleshwar's best sunset viewpoints, attracting visitors with spectacular evening views over the Sahyadri hills."
  }
],




"services": [
  {
    "name": "Belgaum to Mahabaleshwar Taxi",
    "description": "Book Belgaum to Mahabaleshwar Taxi for a safe, comfortable, and scenic journey with professional chauffeurs, clean AC Sedan, Ertiga, Innova Crysta, and SUV vehicles. Enjoy fixed fares, doorstep pickup, one way and round trip options, sightseeing stops, family vacations, business travel, and 24x7 customer support."
  },
  {
    "name": "Belgaum to Mahabaleshwar Cab Service",
    "description": "Choose Belgaum to Mahabaleshwar Cab Service for reliable outstation travel with experienced drivers, transparent pricing, comfortable vehicles, flexible pickup timings, and hassle-free online booking."
  },
  {
    "name": "Belgaum to Mahabaleshwar Taxi Service",
    "description": "Travel with Belgaum to Mahabaleshwar Taxi Service offering sanitized AC vehicles, courteous chauffeurs, fixed pricing, luggage assistance, and comfortable highway journeys."
  },
  {
    "name": "Belgaum to Mahabaleshwar One Way Cab",
    "description": "Reserve Belgaum to Mahabaleshwar One Way Cab with affordable fares, direct destination drop, instant booking confirmation, and professional chauffeur-driven vehicles."
  },
  {
    "name": "Belgaum to Mahabaleshwar Cab Booking",
    "description": "Complete Belgaum to Mahabaleshwar Cab Booking online with secure reservations, transparent pricing, multiple vehicle choices, and quick booking confirmation."
  },
  {
    "name": "Belgaum to Mahabaleshwar Taxi Booking",
    "description": "Book Belgaum to Mahabaleshwar Taxi Booking with fixed fares, comfortable AC cars, experienced drivers, and reliable intercity transportation."
  },
  {
    "name": "Belgaum to Mahabaleshwar Car Rental",
    "description": "Hire Belgaum to Mahabaleshwar Car Rental for flexible travel with Sedan, Ertiga, Innova Crysta, SUVs, and chauffeur-driven vehicles for leisure and business trips."
  },
  {
    "name": "Belgaum to Mahabaleshwar Outstation Cab",
    "description": "Choose Belgaum to Mahabaleshwar Outstation Cab for comfortable long-distance travel with affordable pricing, clean vehicles, and professional drivers."
  },
  {
    "name": "Belgaum to Mahabaleshwar Tour by Cab",
    "description": "Plan your Belgaum to Mahabaleshwar Tour by Cab with customized sightseeing, flexible travel schedules, premium vehicles, and experienced chauffeurs."
  },
  {
    "name": "Belgaum to Mahabaleshwar Innova Crysta Cab",
    "description": "Book Belgaum to Mahabaleshwar Innova Crysta Cab for luxury family travel, group tours, spacious seating, and premium outstation comfort."
  },
  {
    "name": "Belgaum to Mahabaleshwar Ertiga Cab",
    "description": "Reserve Belgaum to Mahabaleshwar Ertiga Cab for comfortable six-seater travel with ample luggage space, affordable pricing, and reliable drivers."
  },
  {
    "name": "Belgaum to Mahabaleshwar Sedan Cab",
    "description": "Travel with Belgaum to Mahabaleshwar Sedan Cab for economical, comfortable, and convenient outstation transportation with professional chauffeurs."
  },
  {
    "name": "Belgaum to Mahabaleshwar SUV Cab",
    "description": "Hire Belgaum to Mahabaleshwar SUV Cab for spacious family trips, group travel, premium comfort, and smooth highway journeys."
  },
  {
    "name": "Belgaum to Mahabaleshwar Round Trip Cab",
    "description": "Book Belgaum to Mahabaleshwar Round Trip Cab with flexible return schedules, fixed pricing, premium vehicles, and dependable chauffeur service."
  },
  {
    "name": "Belgaum to Mahabaleshwar Private Taxi",
    "description": "Choose Belgaum to Mahabaleshwar Private Taxi for exclusive travel with complete privacy, flexible pickup timing, luxury comfort, and personalized service."
  },
  {
    "name": "Cheap Belgaum to Mahabaleshwar Cab",
    "description": "Find Cheap Belgaum to Mahabaleshwar Cab with budget-friendly fares, AC vehicles, professional drivers, and no hidden charges for a comfortable journey."
  },
  {
    "name": "Best Belgaum to Mahabaleshwar Cab Service",
    "description": "Experience the Best Belgaum to Mahabaleshwar Cab Service with premium vehicles, courteous chauffeurs, fixed pricing, online booking, and 24x7 customer support."
  },
  {
    "name": "Online Belgaum to Mahabaleshwar Cab Booking",
    "description": "Reserve Online Belgaum to Mahabaleshwar Cab Booking with instant confirmation, secure payment, transparent fares, and multiple vehicle options."
  },
  {
    "name": "Belgaum to Mahabaleshwar Taxi Fare",
    "description": "Check Belgaum to Mahabaleshwar Taxi Fare with fixed pricing, affordable travel packages, multiple cab categories, and transparent rates."
  },
  {
    "name": "24/7 Belgaum to Mahabaleshwar Cab Service",
    "description": "Book 24/7 Belgaum to Mahabaleshwar Cab Service anytime with round-the-clock availability, professional drivers, clean vehicles, and instant booking support."
  },
  {
    "name": "Belgaum to Mahabaleshwar Tour Package",
    "description": "Choose Belgaum to Mahabaleshwar Tour Package with sightseeing, customized itineraries, premium vehicles, and experienced chauffeurs for a memorable holiday."
  },
  {
    "name": "Belgaum to Mahabaleshwar Car Hire",
    "description": "Hire Belgaum to Mahabaleshwar Car Hire with chauffeur-driven Sedan, Ertiga, Innova Crysta, and SUV vehicles for convenient outstation travel."
  },
  {
    "name": "Belgaum to Mahabaleshwar Travel Package",
    "description": "Book Belgaum to Mahabaleshwar Travel Package with flexible travel plans, sightseeing options, comfortable vehicles, and affordable pricing."
  },
  {
    "name": "Belgaum to Mahabaleshwar Sightseeing Cab",
    "description": "Reserve Belgaum to Mahabaleshwar Sightseeing Cab to explore scenic viewpoints, lakes, temples, strawberry farms, and popular tourist attractions comfortably."
  },
  {
    "name": "Belgaum to Mahabaleshwar Family Cab",
    "description": "Book Belgaum to Mahabaleshwar Family Cab with spacious seating, child-friendly travel, luggage space, and comfortable vehicles for family vacations."
  },
  {
    "name": "Belgaum to Mahabaleshwar Corporate Cab",
    "description": "Choose Belgaum to Mahabaleshwar Corporate Cab for executive travel, business meetings, company tours, and professional chauffeur-driven transportation."
  },
  {
    "name": "Belgaum to Mahabaleshwar Holiday Cab",
    "description": "Reserve Belgaum to Mahabaleshwar Holiday Cab for relaxing vacations with premium vehicles, experienced drivers, flexible schedules, and comfortable travel."
  },
  {
    "name": "Belgaum to Mahabaleshwar Cab Price",
    "description": "Check Belgaum to Mahabaleshwar Cab Price with transparent pricing, fixed fare packages, multiple vehicle choices, and affordable outstation travel."
  },
  {
    "name": "Belgaum to Mahabaleshwar Taxi Near Me",
    "description": "Find Belgaum to Mahabaleshwar Taxi Near Me with quick booking, nearby chauffeur availability, comfortable AC vehicles, and dependable intercity transportation."
  }
],

"tableData": [
  ["Belgaum to Mahabaleshwar Taxi", "Belgaum to Mahabaleshwar Cab Service"],
  ["Belgaum to Mahabaleshwar Taxi Service", "Belgaum to Mahabaleshwar One Way Cab"],
  ["Belgaum to Mahabaleshwar Cab Booking", "Belgaum to Mahabaleshwar Taxi Booking"],
  ["Belgaum to Mahabaleshwar Car Rental", "Belgaum to Mahabaleshwar Outstation Cab"],
  ["Belgaum to Mahabaleshwar Tour by Cab", "Belgaum to Mahabaleshwar Innova Crysta Cab"],
  ["Belgaum to Mahabaleshwar Ertiga Cab", "Belgaum to Mahabaleshwar Sedan Cab"],
  ["Belgaum to Mahabaleshwar SUV Cab", "Belgaum to Mahabaleshwar Round Trip Cab"],
  ["Belgaum to Mahabaleshwar Private Taxi", "Cheap Belgaum to Mahabaleshwar Cab"],
  ["Best Belgaum to Mahabaleshwar Cab Service", "Online Belgaum to Mahabaleshwar Cab Booking"],
  ["Belgaum to Mahabaleshwar Taxi Fare", "24/7 Belgaum to Mahabaleshwar Cab Service"],
  ["Belgaum to Mahabaleshwar Tour Package", "Belgaum to Mahabaleshwar Car Hire"],
  ["Belgaum to Mahabaleshwar Travel Package", "Belgaum to Mahabaleshwar Sightseeing Cab"],
  ["Belgaum to Mahabaleshwar Family Cab", "Belgaum to Mahabaleshwar Corporate Cab"],
  ["Belgaum to Mahabaleshwar Holiday Cab", "Belgaum to Mahabaleshwar Cab Price"],
  ["Belgaum to Mahabaleshwar Taxi Near Me", ""]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Belgaum to Mahabaleshwar Cab Service",
    WhyChoosedescription: "Belgaum Taxi Service provides reliable Belgaum to Mahabaleshwar cab services with comfortable vehicles, skilled drivers, and hassle-free long-distance travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Any Location",
    WhyChoosedescription: "Enjoy convenient pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and surrounding areas with direct drop anywhere in Mahabaleshwar."
  },
  {
    WhyChooseheading: "Wide Choice of Vehicles",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your travel plans, passenger count, and luggage requirements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Hill Routes",
    WhyChoosedescription: "Our professional chauffeurs are experienced in driving through ghat roads, ensuring a safe, smooth, and comfortable journey to Mahabaleshwar."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose one-way cab services or flexible round-trip packages for weekend getaways, vacations, and business travel."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "Travel with confidence using competitive taxi fares, upfront pricing, and no hidden charges for your Belgaum to Mahabaleshwar trip."
  },
  {
    WhyChooseheading: "Ideal for Family Holidays & Group Tours",
    WhyChoosedescription: "Our cabs are perfect for family vacations, honeymoon trips, sightseeing tours, corporate outings, and group travel to Mahabaleshwar."
  },
  {
    WhyChooseheading: "24/7 Booking & Customer Support",
    WhyChoosedescription: "Book your Belgaum to Mahabaleshwar cab anytime with instant confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Mahabaleshwar cab service?",
    answer: "Yes, we offer reliable one-way and round-trip cab services from Belgaum to Mahabaleshwar with professional drivers."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Mahabaleshwar?",
    answer: "Yes, one-way taxi services are available with convenient pickup from any location in Belgaum."
  },
  {
    question: "Which vehicles are available for Belgaum to Mahabaleshwar travel?",
    answer: "You can choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your travel requirements."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup is available from Belgaum Airport, Railway Station, hotels, offices, and residential areas."
  },
  {
    question: "Is Belgaum to Mahabaleshwar cab service available 24/7?",
    answer: "Yes, our taxi services operate 24 hours a day, allowing you to travel at your preferred time."
  },
  {
    question: "Can I book a return cab from Mahabaleshwar to Belgaum?",
    answer: "Yes, round-trip and return taxi services are available with flexible travel schedules."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, state taxes, and applicable charges are generally billed separately unless mentioned in the confirmed quotation."
  },
  {
    question: "Is this cab service suitable for family vacations?",
    answer: "Yes, our spacious and comfortable vehicles are ideal for families, couples, groups, and corporate travelers visiting Mahabaleshwar."
  },
  {
    question: "Can I customize my travel itinerary?",
    answer: "Yes, we provide customized travel plans with optional sightseeing stops based on your schedule and preferences."
  },
  {
    question: "How can I book a Belgaum to Mahabaleshwar Cab?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Patil",
    feedback: "The journey from Belgaum to Mahabaleshwar was smooth and comfortable. The driver was experienced on the hill roads, and the vehicle was clean and well-maintained.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Desai",
    feedback: "We chose Belgaum Taxi Service for our family vacation, and everything exceeded our expectations. The booking was easy, the cab was spacious, and the entire trip was enjoyable.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Mahabaleshwar Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-mahabaleshwar-cab.webp",
  "description":
    "Book Belgaum to Mahabaleshwar Cab with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Mahabaleshwar with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for family trips, sightseeing, and outstation travel.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-mahabaleshwar-cab"
  }
};







    return (
        <div>



<Helmet>
  <title>Belgaum to Mahabaleshwar Cab | Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Mahabaleshwar Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Travel from Belgaum to Mahabaleshwar with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for comfortable outstation journeys."
  />

  <meta
    name="keywords"
    content="Belgaum to Mahabaleshwar Taxi, Belgaum to Mahabaleshwar Cab Service, Belgaum to Mahabaleshwar Taxi Service, Belgaum to Mahabaleshwar Cab, Belgaum Mahabaleshwar Cabs, Belgaum to Mahabaleshwar One Way Taxi, Belgaum to Mahabaleshwar Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtomahabaleshwarcab;